import { Product } from "../types/Product";
import CowPartImage from "./CowPartImage";
import ChickenPartImage from "./ChickenPartImage";
import PorkPartImage from "./PorkPartImage";

interface Props {
  product: Product;
}

const ProductPartImage = ({ product }: Props) => {

    const views = {
        cow: <CowPartImage product={product}/>,
        chicken: <ChickenPartImage product={product}/>,
        pork: <PorkPartImage product={product} />,
    }
    
    return views[product.animal]
    
}

export default ProductPartImage